import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Animated, Easing, View } from 'react-native';

import { HorizontalDashes } from '../../dashes';
import { SEPARATOR_STROKE } from '../../../../constants';

import styles from './expandable-list-row-content.styles';

const BODY_ANIMATION_DELAY = 100;
const ANIMATION_DURATION = 300;

export default class ExpandableListRowContent extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor() {
    super();

    this.state = {
      bodyAnim: new Animated.Value(0),
    };
  }

  componentDidMount() {
    Animated.timing(
      this.state.bodyAnim,
      {
        toValue: 1,
        easing: Easing.easeOut,
        duration: ANIMATION_DURATION,
        delay: BODY_ANIMATION_DELAY,
      }
    ).start();
  }

  componentWillUnmount() {
    Animated.timing(
      this.state.bodyAnim,
      {
        duration: ANIMATION_DURATION,
        toValue: 0,
        easing: Easing.easeOut,
      }
    ).start();
  }

  render() {
    const { children } = this.props;
    const { bodyAnim } = this.state;
    const translateX = {
      translateX: bodyAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [-6, 0],
      }),
    };
    const translateY = {
      translateY: bodyAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [8, 0],
      }),
    };

    return (
      <Animated.View
        style={[
          styles.root,
          { opacity: bodyAnim },
          { transform: [translateX, translateY] },
        ]}
      >
        {/* <View style={styles.separator}>
          <HorizontalDashes stroke={SEPARATOR_STROKE} />
        </View> */}
        {children}
      </Animated.View>
    );
  }
}
